import {FC, useEffect, useState} from 'react'
import {Routes, Route, Navigate, useLocation} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {AuthPage} from '../features/auth'
import StorePage from '../features/signup/StorePage'
import {ErrorsPage} from '../features/errors/ErrorsPage'
import {RootState} from '../../setup'
import {SubscriptionProvider} from 'app/features/subscription/SubscriptionContext'
import IntercomSDK from 'intercom'

const excludedUrl = (pathname: string) => {
  return pathname.indexOf('auth') > 0 || pathname === '/store'
}

const AppRoutes: FC = () => {
  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const isLoggedOut = useSelector<RootState>(({auth}) => auth.isLoggedOut, shallowEqual)
  const location = useLocation()
  const [redirectUrl, setRedirectUrl] = useState('/')

  useEffect(() => {
    if (!excludedUrl(location.pathname) && !isAuthorized) {
      setRedirectUrl(location.pathname)
    } else if (isLoggedOut) {
      setRedirectUrl('/')
    }
  }, [location, isAuthorized, isLoggedOut])

  return (
    <Routes>
      <Route path='store/*' element={<StorePage />} />

      <Route path='auth/*' element={!isAuthorized ? <AuthPage /> : <Navigate to={redirectUrl} />} />

      <Route path='error/*' element={<ErrorsPage />} />

      {/* Redirect unauthorized users to `/auth` */}
      {!isAuthorized ? (
        <Route path='/*' element={<Navigate to='/auth/login' />} />
      ) : (
        <Route
          path='*'
          element={
            <MasterLayout>
              <SubscriptionProvider redirectUrl={redirectUrl}>
                <IntercomSDK />
                <PrivateRoutes />
              </SubscriptionProvider>
            </MasterLayout>
          }
        />
      )}
    </Routes>
  )
}

export {AppRoutes}
